import { create } from 'zustand';

interface ConfirmButton {
  text: string;
  onClick: () => void;
}

interface ConfirmState {
  isOpen: boolean;
  title: string;
  text: string;
  buttons: ConfirmButton[];
  resolve: ((value: boolean) => any) | null;
  openConfirm: (title: string, text: string, buttons: ConfirmButton[]) => Promise<any>;
  closeConfirm: () => void;
}

export const useConfirmStore = create<ConfirmState>((set) => ({
  isOpen: false,
  title: '',
  text: '',
  buttons: [],
  resolve: null,
  openConfirm: (title: string, text: string, buttons: ConfirmButton[]) =>
    new Promise<any>((resolve) => {
      set({ isOpen: true, title, text, buttons, resolve });
    }),
  closeConfirm: () => set({ isOpen: false, buttons: [], resolve: null }),
}));

